import React from "react";
import { ItemGroupSummary, PurchaseHistory, PickUpPage } from '../component';
import GenerateOrderSummaryItems from "../common/GenerateOrderSummaryItems";
import { AboveTheFoldMarker, CriticalFeatureMarker, FunctionalMarker } from "../csa/markers";
import { PickupInstructionsBreadCrumb } from "../common/BreadCrumb";

interface PostPickupPageProps {
    itemGroupSummary: ItemGroupSummary;
    purchaseHistory: PurchaseHistory;
    pickupPage: PickUpPage;
}

/**
 * Post-Pickup page component
 * Displays information about an order that has been picked up from a pharmacy kiosk
 */
const PostPickupPage: React.FC<PostPickupPageProps> = (props) => {
    return (
        <>
            <pui-stack spacingBottom="small">
                <PickupInstructionsBreadCrumb 
                    yourOrders={props.purchaseHistory.labels.yourOrders} 
                    pickUpInstructionsLabel={props.pickupPage.labels.kioskPickUpInstructionsLabel}
                />
            </pui-stack>
            <pui-stack id="post-pickup-page"
                data-csa-c-content-id="post-pickup-page"
                data-csa-c-type="card"
                data-csa-c-slot-id="post-pickup">
                <pui-heading input={props.itemGroupSummary.headline} headingLevel="1" textSize="large"
                    spacingBottom="medium" />

                <pui-heading input={props.pickupPage.labels.amazonPharmacyKiosk} textSize="small"/>
                <pui-text input={props.pickupPage.instructions.kioskPickUpAddress}/>
                <pui-text encode input={props.pickupPage.instructions.kioskPickUpHours}
                          style={{whiteSpace: "pre-line"}}/>
                <AboveTheFoldMarker/>
                <CriticalFeatureMarker/>
            </pui-stack>


            <pui-heading input={props.pickupPage.labels.orderSummary} headingLevel="2" textSize="medium"
                spacingBottom="small" />
            <GenerateOrderSummaryItems
                itemGroupSummary={props.itemGroupSummary}
            />
            <pui-divider spacingTop="small" />

            <FunctionalMarker />
        </>
    );
};

export default PostPickupPage;
